<template>
  <div class="borrower-form">
    <validation-observer ref="observer" v-slot="{ passes }">
      <b-form :novalidate="true" class="borrower-form__form" @submit.stop.prevent="passes(submit)">
        <b-row>
          <b-col>
            <forms-validated-input
              v-model="borrower.drivers_license_number"
              name="drivers_license_number"
              type="text"
              :disabled="disabled"
              :label="$t('borrowers.fields.drivers_license_number') | capitalize"
              :placeholder="placeholderOrLabel('drivers_license_number', 'borrowers') | capitalize"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <forms-validated-input
              v-model="borrower.has_not_been_sued_last_ten_years"
              name="has_not_been_sued_last_ten_years"
              type="checkbox"
              :disabled="disabled"
              :label="$t('borrowers.fields.no_suit_confirmation')"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <forms-files-uploader
              ref="saaqFiles"
              v-model="borrower.saaq"
              field="saaq"
              :disabled="disabled"
              :label="$t('borrowers.fields.saaq') | capitalize"
              @uploading="uploadingSaaq = true"
              @uploaded="uploadingSaaq = false"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <forms-files-uploader
              ref="gaaFiles"
              v-model="borrower.gaa"
              field="gaa"
              :disabled="disabled"
              :label="$t('borrowers.fields.gaa') | capitalize"
              @uploading="uploadingGaa = true"
              @uploaded="uploadingGaa = false"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div>
              <p>{{ $t("borrowers.no_documents_message") }}</p>

              <ul>
                <li>
                  <a :href="$t('resources.saaq_url')" target="_blank">
                    {{ $t("borrowers.saaq_document_link") }}
                  </a>
                </li>
                <li>
                  <a :href="$t('resources.gaa_url')" target="_blank">
                    {{ $t("borrowers.gaa_document_link") }}
                  </a>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>

        <icon-button
          role="send"
          type="submit"
          :disabled="!changed || !isComplete || loading || uploadingFile"
        >
          {{ $t("forms.submit") | capitalize }}
        </icon-button>
        &nbsp;
        <icon-button
          v-if="!borrower.submitted_at"
          variant="link"
          type="submit"
          :disabled="!changed || loading || uploadingFile"
        >
          {{ $t("borrowers.forms.save_without_submit") | capitalize }}
        </icon-button>
        <layout-loading v-if="loading || uploadingFile" with-button />
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import FormsFilesUploader from "@/components/Forms/FilesUploader.vue";
import FormsValidatedInput from "@/components/Forms/ValidatedInput.vue";
import LayoutLoading from "@/components/Layout/Loading.vue";
import IconButton from "@/components/shared/IconButton.vue";
import FormLabelsMixin from "@/mixins/FormLabelsMixin";

export default {
  name: "BorrowerForm",
  components: {
    IconButton,
    LayoutLoading,
    FormsValidatedInput,
    FormsFilesUploader,
  },
  mixins: [FormLabelsMixin],
  props: {
    borrower: {
      type: Object,
      required: true,
    },
    changed: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      uploadingSaaq: false,
      uploadingGaa: false,
    };
  },
  computed: {
    uploadingFile() {
      return this.uploadingSaaq || this.uploadingGaa;
    },
    isComplete() {
      return (
        this.borrower.drivers_license_number &&
        this.borrower.has_not_been_sued_last_ten_years &&
        this.borrower.gaa?.length > 0 &&
        this.borrower.saaq?.length > 0
      );
    },
  },
  methods: {
    submit(...params) {
      if (this.isComplete) {
        this.$emit("submit");
      } else {
        this.$emit("save", ...params);
      }
    },
  },
};
</script>

<style lang="scss"></style>
